/**
 * V205 — código de fidelidad (espejo del backend `loyalty-code.ts`): 8 caracteres del
 * alfabeto sin O/0, I/1, S/5; se muestra "ABCD-2346" y se acepta con o sin guion.
 */
export const LOYALTY_ALPHABET = 'ABCDEFGHJKLMNPQRTUVWXYZ2346789';

export const normalizeLoyaltyCode = (raw: string): string => raw.toUpperCase().replace(/[^A-Z0-9]/g, '');

export const formatLoyaltyCode = (code: string): string =>
  code.length === 8 ? `${code.slice(0, 4)}-${code.slice(4)}` : code;

/** ¿Lo tecleado es un teléfono (≥10 dígitos y nada más que dígitos/separadores)? */
export const looksLikePhone = (raw: string): boolean =>
  /^[\d\s()+-]+$/.test(raw.trim()) && raw.replace(/\D/g, '').length >= 10;
